<template>
  <aside class="payment-summary">
    <div class="payment-summary__head">
      <div>
        <div class="payment-summary__label">
          К ОПЛАТЕ:
        </div>
        <div class="payment-summary__headline">
          {{ headline }}
          <span v-if="headlineNote" class="payment-summary__headline-note">{{ headlineNote }}</span>
        </div>
      </div>

      <img class="payment-summary__image" src="/img/wallet.png" alt="">
    </div>

    <dl class="payment-summary__rows">
      <div class="payment-summary__row">
        <dt>Способ оплаты</dt>
        <dd class="payment-summary__value">
          {{ methodLabel }}
        </dd>
      </div>
      <div class="payment-summary__row">
        <dt>Баланс сейчас</dt>
        <dd :class="['payment-summary__value', { 'payment-summary__value_negative': balance < 0 }]">
          {{ formatSigned(balance) }}
        </dd>
      </div>
      <div v-if="balanceChanges" class="payment-summary__row">
        <dt>Баланс после пополнения</dt>
        <dd :class="['payment-summary__value', balanceAfter < 0 ? 'payment-summary__value_negative' : 'payment-summary__value_positive']">
          {{ formatSigned(balanceAfter) }}
        </dd>
      </div>
      <div v-if="daysLabel" class="payment-summary__row">
        <dt>Кол-во дней по тарифу</dt>
        <dd class="payment-summary__value">
          {{ daysLabel }}
        </dd>
      </div>
    </dl>

    <v-btn
      class="payment-summary__btn"
      block
      x-large
      depressed
      :disabled="disabled"
      :loading="loading"
      @click="$emit('submit')"
    >
      {{ submitText }}
    </v-btn>
  </aside>
</template>

<script>
  export default {
    name: 'PaymentSummary',
    props: {
      amount: {
        type: Number,
        default: 0,
      },
      balance: {
        type: Number,
        default: 0,
      },
      dailyRate: {
        type: Number,
        default: 0,
      },
      methodLabel: {
        type: String,
        default: '—',
      },
      headline: {
        type: String,
        required: true,
      },
      headlineNote: {
        type: String,
        default: null,
      },
      daysOverride: {
        type: String,
        default: null,
      },
      submitText: {
        type: String,
        default: 'ОПЛАТИТЬ',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      balanceChanges: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      balanceAfter () {
        return this.balance + this.amount
      },
      daysLabel () {
        if (this.daysOverride) return this.daysOverride
        if (!this.dailyRate) return null
        const days = Math.floor(this.balanceAfter / this.dailyRate)
        return days > 0 ? `~${days} дней` : null
      },
    },
    methods: {
      formatSigned (rubles) {
        const sign = rubles > 0 ? '+' : ''
        return `${sign}${rubles.toLocaleString('ru-RU')} ₽`
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-summary {
  // рамку и скругление держит общая карточка страницы: сводка — её правая половина
  background-color: #fdf3dc;
  padding: 32px;

  .media-xs({
    padding: 20px 16px;
  });

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
  }

  &__image {
    flex: 0 0 auto;
    // по макету кошелёк занимает ~22% ширины панели
    width: 140px;
    height: auto;

    .media-xs({
      width: 100px;
    });
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: #757575;
  }

  &__headline {
    margin-top: 6px;
    font-size: 43px;
    font-weight: 500;
    color: #323030;
    line-height: 1.2;

    // рядом с кошельком на узкой панели кегль макета уже не помещается
    .media-xs({
      font-size: 32px;
    });

    &-note {
      display: block;
      color: #ea306b;
    }
  }

  &__rows {
    // в макете блок отбит от суммы заметным воздухом
    margin: 52px 0 0;
    padding: 20px 0;
    border-top: 1px solid #e1cd9d;
    border-bottom: 1px solid #e1cd9d;

    .media-xs({
      margin-top: 28px;
    });
  }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 16px;
    padding: 12px 0;

    dt {
      font-size: 15px;
      color: #323030;
    }
  }

  // цвет держим на самом значении: правило вида `.payment-summary__row dd`
  // специфичнее модификатора и перебивало бы его
  &__value {
    margin: 0;
    font-size: 15px;
    font-weight: 500;
    color: #323030;
    text-align: right;

    &_negative {
      color: #ea306b;
    }

    &_positive {
      color: #4caf50;
    }
  }

  &__btn.v-btn {
    margin-top: 40px;
    background-color: @color-primary !important;
    color: #fff !important;
    border-radius: 4px;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
}
</style>
